import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';

const NameDialog = ({
  onRename,
  currentName,
  isOpen,
  setIsOpen,
  type,
  actionName = 'Rename',
}: {
  onRename: (str: string) => void;
  currentName: string;
  isOpen: boolean;
  setIsOpen: (newValue: boolean) => void;
  type: string;
  actionName?: string;
}) => {
  const [name, setName] = useState(currentName);

  useEffect(() => {
    setName(currentName);
  }, [currentName, isOpen]);

  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  };

  const handleRename = () => {
    if (name.trim() === '') {
      enqueueSnackbar('Name cannot be empty', { variant: 'error' });
      return;
    }
    onRename(name.trim());
    setName(name);
    setIsOpen(false);
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={handleCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">What would you like to name this {type}?</DialogTitle>
        <DialogContent style={{ paddingTop: '10px' }}>
          <TextField
            label={`${type[0].toUpperCase() + type.substring(1)} Name`}
            type="text"
            value={name}
            onChange={handleNameChange}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="primary">
            Cancel
          </Button>
          <Button onClick={handleRename} color="primary" autoFocus>
            {actionName}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default NameDialog;
